/**
 * Booking constants - Status configuration, keywords for location detection
 */

// Keywords pour détecter les aéroports et gares
export const AIRPORT_KEYWORDS = ['aéroport', 'airport', 'cdg', 'orly', 'beauvais', 'terminal', 'roissy', 'charles de gaulle', 'le bourget'];
export const TRAIN_STATION_KEYWORDS = ['gare', 'station', 'sncf', 'tgv', 'eurostar', 'montparnasse', 'saint-lazare', 'lyon', 'nord', 'est', 'austerlitz'];

// Detect location type (airport/train station)
export const detectLocationType = (address) => {
  if (!address) return null;
  const addressLower = address.toLowerCase();
  if (AIRPORT_KEYWORDS.some(kw => addressLower.includes(kw))) return 'airport';
  if (TRAIN_STATION_KEYWORDS.some(kw => addressLower.includes(kw))) return 'train';
  return null;
};

// Status configuration
export const STATUS_CONFIG = {
  '0': { label: 'Devis envoyé', color: 'bg-white border border-gray-400', textColor: 'text-gray-700', description: 'Votre demande est en cours de traitement' },
  '1': { label: 'Réservation reçue', color: 'bg-yellow-400', textColor: 'text-black', description: 'Nous avons bien reçu votre réservation' },
  '2': { label: 'Confirmée', color: 'bg-green-500', textColor: 'text-white', description: 'Votre réservation est confirmée' },
  '3': { label: 'En attente d\'attribution', color: 'bg-orange-500', textColor: 'text-white', description: 'Nous recherchons un chauffeur' },
  '4': { label: 'Chauffeur attribué', color: 'bg-sky-400', textColor: 'text-white', description: 'Un chauffeur vous a été attribué' },
  '5': { label: 'Chauffeur confirmé', color: 'bg-blue-700', textColor: 'text-white', description: 'Le chauffeur a accepté la mission' },
  '6': { label: 'En approche', color: 'bg-pink-500', textColor: 'text-white', description: 'Votre chauffeur est en route' },
  '7': { label: 'Sur place', color: 'bg-violet-600', textColor: 'text-white', description: 'Votre chauffeur est arrivé' },
  '8': { label: 'Déposé', color: 'bg-amber-800', textColor: 'text-white', description: 'Vous avez été déposé à destination' },
  '9': { label: 'Mission terminée', color: 'bg-gray-900', textColor: 'text-white', description: 'La course est terminée' },
  'V': { label: 'En vérification', color: 'bg-cyan-500', textColor: 'text-white', description: 'En cours de vérification' },
  'F': { label: 'En facturation', color: 'bg-lime-400', textColor: 'text-black', description: 'Facturation en cours' },
  'C': { label: 'Dossier clos', color: 'bg-gray-400', textColor: 'text-white', description: 'Dossier clôturé' },
  'A': { label: 'Annulée', color: 'bg-red-600', textColor: 'text-white', description: 'Cette réservation a été annulée' },
  'pending': { label: 'En attente', color: 'bg-yellow-500', textColor: 'text-black', description: 'En attente de confirmation' },
  'pending_payment': { label: 'Paiement en attente', color: 'bg-orange-500', textColor: 'text-white', description: 'En attente de paiement' },
  'confirmed': { label: 'Confirmée', color: 'bg-green-500', textColor: 'text-white', description: 'Votre réservation est confirmée' },
  'draft': { label: 'Brouillon', color: 'bg-gray-400', textColor: 'text-white', description: 'Réservation en cours de création' },
  'cancelled': { label: 'Annulée', color: 'bg-red-600', textColor: 'text-white', description: 'Cette réservation a été annulée' },
  'completed': { label: 'Terminée', color: 'bg-gray-900', textColor: 'text-white', description: 'La course est terminée' },
};

// Status codes where driver has accepted (no more self-service modifications)
export const DRIVER_ACCEPTED_STATUSES = ['5', '6', '7', '8', '9', 'V', 'F'];

// Helper to get status config
export const getStatusConfig = (statusCode, status) => {
  const code = statusCode || status;
  return STATUS_CONFIG[code] || STATUS_CONFIG['pending'] || {
    label: code || 'Inconnu', color: 'bg-gray-500', textColor: 'text-white', description: ''
  };
};

// Helper functions
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  });
};

export const formatTime = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};
